import SearchInput from '../../../components/ui/SearchInput';
import Select from '../../../components/ui/Select';
import {
    WHATSAPP_PROVIDER_FILTERS,
    WHATSAPP_STATUS_BUCKET_FILTERS,
} from '../../../domain/superadmin/whatsappFilters';
import type { AdminWhatsappFilters } from '../hooks/useAdminWhatsappInstances';

type Props = {
    filters: AdminWhatsappFilters;
    search: string;
    onSearch: (value: string) => void;
    onChange: (patch: Partial<AdminWhatsappFilters>) => void;
};

const ALL = { value: '', label: 'Todos' };

function withAll(
    options: { value: string; label: string }[],
): { value: string; label: string }[] {
    return [ALL, ...options];
}

export function WhatsappInstancesFilters({ filters, search, onSearch, onChange }: Props) {
    return (
        <section
            aria-label="Filtros e busca"
            className="mb-s4 flex flex-col gap-s3 lg:flex-row lg:items-end"
        >
            <div className="grid flex-1 grid-cols-1 gap-s3 sm:grid-cols-2">
                <Select
                    label="Status"
                    selectSize="sm"
                    value={filters.statusBucket}
                    options={withAll(WHATSAPP_STATUS_BUCKET_FILTERS)}
                    onChange={(e) => onChange({ statusBucket: e.target.value })}
                />
                <Select
                    label="Provedor"
                    selectSize="sm"
                    value={filters.provider}
                    options={withAll(WHATSAPP_PROVIDER_FILTERS)}
                    onChange={(e) => onChange({ provider: e.target.value })}
                />
            </div>

            <div className="w-full lg:w-72">
                <SearchInput
                    value={search}
                    onChange={onSearch}
                    placeholder="Buscar por org, telefone..."
                />
            </div>
        </section>
    );
}
